// extracted by mini-css-extract-plugin
export var capsules = "filter-bar-module--capsules--27ec4";
export var filterBar = "filter-bar-module--filterBar--9f9ec";
export var specialCapsule = "filter-bar-module--specialCapsule--90bc8";